export const CONSECUTIVE_ALERT_THRESHOLD = 3;
export const CONSECUTIVE_ALERT_KEY = 'cnj';
export const CONSECUTIVE_ALERT_PAGE_SIZE = 10;
export const DASHBOARD_PANEL_ERROS_CONSECUTIVOS = 'erros-consecutivos';
export const ERROS_CONSECUTIVOS_ALERT_LABEL = '3+ erros em sequência';

export const CONSUMOS_ALERTS_REFRESH_INTERVAL_MS = 60 * 60 * 1000;
export const CONSUMOS_ROUTE = '/consumos';
export const LOW_BREAKER_BALANCE_ALERT_LABEL = 'Quebrador com pouco saldo';
export const NO_BREAKER_BALANCE_ALERT_LABEL = 'Quebrador sem saldo';
export const NO_PROXY_BALANCE_ALERT_LABEL = 'Proxie sem saldo';
